<template>
  <el-dialog
    :visible.sync="editShow"
    width="50%"
    title="活动规则"
    :close-on-click-modal="false"
  >
  <p>
    设置活动的优惠规则、联报课程的选择条件和数量等信息。[添加规则]->[添加规则条件]
  </p>
  <div class="title">
            活动优惠规则
        </div>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        <div>
           {{row.is_group ? '【团】' : ''}}
          {{ $getLabel(ruleType, row.rule_type) }}
        </div>
      </template>
      <template #amount="{ row }">
        <div v-if="row.rule_type == 'discount'">
          折扣{{ row.discount_rate }}
        </div>
        <div v-if="row.rule_type == 'reduce'">
          优惠 {{ row.reduce_amount }}元
        </div>
        <div v-if="row.rule_type == 'cashBack'">
          返现 {{ row.discount_rate }}
        </div>
        <div v-if="row.rule_type == 'cashBackA'">
          返现金额 {{ row.reduce_amount }}元
        </div>
      </template>

      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="settingCondition(row)"
            >编辑</el-button
          >
          <el-button type="primary" size="small" @click="settingCondition(row)"
            >规则条件</el-button
          >
          <el-button type="danger" size="small" @click="del(row)"
            >删除</el-button
          >
        </div>
      </template>
    </auto-table>
    <el-form>
      <el-button type="primary" icon="el-icon-plus" v-if="form.id" circle @click="form = {}"></el-button>
      <el-form-item label="规则类型">
        <el-radio-group v-model="form.rule_type" @change="ruleTypeChange">
          <el-radio v-for="(v, i) in ruleType" :key="i" :label="v.value">{{
            v.label
          }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="是否团购">
          <el-switch
            v-model="form.is_group"
            active-text="团"
            inactive-text="">
          </el-switch>
          <div>非团购情况优惠规则生效</div>
          <div>团购情况返现规则生效</div>
      </el-form-item>
      <el-form-item label="折扣" v-if="form.rule_type == 'discount'">
        <el-input v-model="form.discount_rate"></el-input>
        <div>支付金额 = 课程金额 * 折扣</div>
      </el-form-item>
      <el-form-item label="返现比例" v-if="form.rule_type == 'cashBack'">
        <el-input v-model="form.discount_rate"></el-input>
         <div>返现金额 = 课程金额 * 返现比例</div>
      </el-form-item>
      <el-form-item label="返现金额" v-if="form.rule_type == 'cashBackA'">
        <el-input v-model="form.reduce_amount"></el-input>
      </el-form-item>
      <el-form-item label="优惠金额" v-if="form.rule_type == 'reduce'">
        <el-input v-model="form.reduce_amount"></el-input>
          <div>支付金额 = 课程金额 - 优惠金额</div>
      </el-form-item>
       <el-form-item label="规则名称" required>
        <el-input v-model="form.name"></el-input>
      </el-form-item>
       <el-form-item label="规则说明">
        <el-input v-model="form.descr"></el-input>
      </el-form-item>

    <div v-if="form.id">
        <div class="title">
            规则条件
        </div>
        <el-button type="text" @click="addInnerVisible"
        >添加使用条件</el-button
      >
      <auto-table
        :DataList="conditionList"
        :option="conditionOption"
        :total="conditionTotal"
        @changePage="getListCondition"
      >
        <template #type="{ row }">
          <div>
            {{ $getLabel(conditionType, row.condition_type) }}
          </div>
        </template>

        <template #handler="{ row }">
          <div>
            <el-button
              type="primary"
              size="small"
              @click="openUpdateCondition(row)"
              >编辑</el-button
            >
            <el-button type="danger" size="small" @click="delCondition(row)"
              >删除</el-button
            >
          </div>
        </template>
      </auto-table>
    </div>

      

      <el-form-item label="">
        <el-button v-if="form.id" type="primary" @click="updateRuleInfo()"
          >更新规则</el-button
        >
        <el-button v-else type="success" @click="addRuleInfo()"
          >添加规则</el-button
        >
      </el-form-item>
    </el-form>

    <el-dialog
      width="30%"
      title="课程选择条件"
      :visible.sync="innerVisible"
      append-to-body
    >
      <el-form>
        <el-form-item label="条件类型">
          <el-radio-group v-model="condition.condition_type">
            <el-radio
              v-for="(v, i) in conditionType"
              :key="i"
              :label="v.value"
              >{{ v.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="类目"
        >
          <el-radio-group v-model="condition.target">
            <el-radio
              v-for="(v, i) in mainCategory"
              :key="i"
              :label="v.value"
              >{{ v.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
          <el-form-item label="条件名称" required>
          <el-input v-model="condition.name" placeholder="名称/子类目名称"></el-input>
          <div>一二级类目请填写类目名称</div>
        </el-form-item>
        <el-form-item label="最低选择" required>
          <el-input v-model="condition.required_value"></el-input>
        </el-form-item>
         <el-form-item label="最高选择" required>
          <el-input v-model="condition.max_value"></el-input>
        </el-form-item>

        <el-form-item label="">
          <el-button
            v-if="condition.id"
            type="primary"
            @click="updateCondition"
            >更新规则</el-button
          >
          <el-button v-else type="success" @click="addCondition"
            >添加规则</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
 
  </el-dialog>
</template>

<script>
import { ruleType, conditionType, mainCategory } from "./dict.js";
export default {
  data() {
    return {
      form: {},
      DataList: [],
      Option: [
        { name: "类型", value: "type", type: "custom" },
        { name: "优惠", value: "amount", type: "custom" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      conditionList: [],
      conditionOption: [
        { name: "类型", value: "type", type: "custom" },
        { name: "条件", value: "target" },
        { name: "最低", value: "required_value" },
        { name: "最高", value: "max_value" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      conditionTotal: 0,
      ruleType,
      conditionType,
      mainCategory,
      editShow: false,
      innerVisible: false,
      activity: {},
      condition: {},
    };
  },

  mounted() {},

  methods: {
    ruleTypeChange(v){
      if(v.includes('cashBack')){
        this.form.is_group = true
      }else{
        this.form.is_group = false
      }
    },
    addInnerVisible() {
      this.innerVisible = true;
      this.condition = {};
    },
    open(row) {
      this.activity = row;
      this.getList(1);
      this.editShow = true;
      this.conditionList = []
      this.form = {}
    },
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/activityRule/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          activity_id: this.activity.id,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
    updateRuleInfo() {
      let data = {
        ...this.form,
      };
      this.$post("/user/activityRule/update", data).then((res) => {
        this.getList(1);
        this.form = {}
      });
    },
    addRuleInfo() {
      if(this.Total >= 1){
        this.$message('已有一条规则')
        return
       }
         if(!this.form.rule_type){
                return
        }
      let data = {
        ...this.form,
        activity_id: this.activity.id,
      };
      this.$post("/user/activityRule/insert", data).then((res) => {
        this.getList(1);
         this.form = {}
      });
    },
    del(row) {
      let data = {
        id: row.id,
      };
      this.$get("/user/activityRule/delete", data).then((res) => {
        this.getList(1);
      });
    },
    // -------------活动条件-------
    getListCondition(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/activityRuleCondition/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          rule_id: this.form.id,
        },
      }).then((res) => {
        this.conditionList = res.data.data.rows;
        this.conditionTotal = res.data.data.total;
      });
    },
    updateCondition() {
      let data = {
        ...this.condition,
      };
      this.$post("/user/activityRuleCondition/update", data).then((res) => {
        this.getListCondition(1);
        this.innerVisible = false;
      });
    },
    addCondition() {
      let data = {
        ...this.condition,
        rule_id: this.form.id,
        activity_id: this.activity.id,
      };
      this.$post("/user/activityRuleCondition/insert", data).then((res) => {
        this.getListCondition(1);
          this.innerVisible = false;
      });
    },
    openUpdateCondition(row) {
      this.condition = row;
      this.innerVisible = true;
    },
    settingCondition(row){
        this.form = {...row}
        this.getListCondition(1);
    },
    delCondition(row) {
      let data = {
        id: row.id,
      };
      this.$get("/user/activityRuleCondition/delete", data).then((res) => {
        this.getListCondition(1);
          this.innerVisible = false;
      });
    },
  },
};
</script>